import React, { useState } from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { Button } from '../components/Button';
import { PlayIcon, ArrowLeft, X } from 'lucide-react';
interface Slide12Props {
  onBack: () => void;
}
export function Slide12({
  onBack
}: Slide12Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <SlideLayout footer="¹ Vabysmo® Summary of Product Characteristics (SmPC/RCP), May 2024." progress={{
    current: 1,
    total: 1
  }} onBack={onBack} data-id="element-81">
      <div className="w-full max-w-7xl mx-auto grid grid-cols-5 gap-8 items-center" data-id="element-82">
        <div className="col-span-3 space-y-6" data-id="element-83">
          <h1 className="text-3xl font-bold text-white mb-2 uppercase" data-id="element-84">
            DOUBLE INHIBITION
          </h1>
          <div className="space-y-4" data-id="element-85">
            <p className="text-xl text-white font-bold uppercase leading-snug" data-id="element-86">
              BY INHIBITING BOTH VEGF-A AND ANG-2, FARICIMAB:¹
            </p>
            <ul className="space-y-2 text-lg text-white font-bold pl-4" data-id="element-87">
              <li className="flex items-center" data-id="element-88">
                <span className="w-2 h-0.5 bg-white mr-3" data-id="element-89"></span>
                <span data-id="element-90">REDUCES VASCULAR PERMEABILITY</span>
              </li>
              <li className="flex items-center" data-id="element-91">
                <span className="w-2 h-0.5 bg-white mr-3" data-id="element-92"></span>
                <span data-id="element-93">REDUCES INFLAMMATION</span>
              </li>
              <li className="flex items-center" data-id="element-94">
                <span className="w-2 h-0.5 bg-white mr-3" data-id="element-95"></span>
                <span data-id="element-96">INHIBITS PATHOLOGICAL ANGIOGENESIS</span>
              </li>
              <li className="flex items-center" data-id="element-97">
                <span className="w-2 h-0.5 bg-white mr-3" data-id="element-98"></span>
                <span data-id="element-99">HELPS RESTORE VASCULAR STABILITY</span>
              </li>
            </ul>
          </div>
          <div className="pt-4" data-id="element-100">
            <Button variant="primary" onClick={onBack} data-id="element-101">
              BACK TO MENU
            </Button>
          </div>
        </div>
        <div className="col-span-2 flex items-center justify-center" data-id="element-102">
          <button onClick={() => setIsModalOpen(true)} className="w-full aspect-video rounded-xl shadow-2xl flex items-center justify-center relative overflow-hidden cursor-pointer hover:opacity-90 transition-opacity border-4 border-white/20" type="button" data-id="element-103">
            {/* Background Image */}
            <img src="https://cdn.magicpatterns.com/uploads/7zbxHPJqTr6AEKXahx5AQh/Screenshot_2026-02-16_at_15.47.04.png" alt="VEGF-A and ANG-2 visualization" className="absolute inset-0 w-full h-full object-cover" data-id="element-104" />
            {/* Text Overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col items-center justify-center space-y-4 backdrop-blur-sm" data-id="element-105">
              <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center border-2 border-white/50" data-id="element-106">
                <PlayIcon className="w-10 h-10 text-white ml-1" data-id="element-107" />
              </div>
              <div className="text-white text-center" data-id="element-108">
                <p className="text-lg font-bold uppercase tracking-wide" data-id="element-109">
                  WATCH VIDEO
                </p>
              </div>
            </div>
          </button>
        </div>
      </div>

      {/* Modal Popup */}
      {isModalOpen && <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 backdrop-blur-md" onClick={() => setIsModalOpen(false)} data-id="element-110">
          <div className="relative bg-black rounded-2xl shadow-2xl max-w-[70vw] max-h-[70vh] w-[70vw] overflow-hidden border border-white/20" onClick={e => e.stopPropagation()} data-id="element-111">
            {/* Close Button */}
            <button onClick={() => setIsModalOpen(false)} className="absolute top-4 right-4 z-10 bg-white/20 hover:bg-white/40 rounded-full p-2 transition-colors backdrop-blur-md" type="button" data-id="element-112">
              <X className="w-6 h-6 text-white" data-id="element-113" />
            </button>
            {/* Modal Content */}
            <div className="w-full h-full" data-id="element-114">
              <img src="https://cdn.magicpatterns.com/uploads/7zbxHPJqTr6AEKXahx5AQh/Screenshot_2026-02-16_at_15.47.04.png" alt="VEGF-A and ANG-2 visualization - Full view" className="w-full h-full object-contain" data-id="element-115" />
            </div>
          </div>
        </div>}
    </SlideLayout>;
}